import React, { useEffect } from 'react';
import { Typography, Form, Alert } from "antd";
import CustomButton from '../../../components/CustomButton/Button';
import CustomInput from '../../../components/CustomInput/Input';
import CustomSelect from '../../../components/CustomSelect/CustomSelect';
import { useDispatch, useSelector } from "react-redux";
import { address1Rules, address2Rules, capitalizeWords, cityRules, pincodeRules } from '../../../helpers/helpers';
import { getAllStates, updateAddressDetails, getInvestorDetailsByOrgId, clearProfileError } from '../../../redux/slices/ProfileSlice';
import { BTN_TXT, ERROR_MSGS } from '../../../constants/constants';

const { Title } = Typography;

const ComAddressForm = ({ investorData, setComAddEditModalOpen }) => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.auth);
  const { statesData, editAddLoading, editAddError } = useSelector((state) => state.profile);

  useEffect(() => {
    dispatch(getAllStates());
    return () => {
      dispatch(clearProfileError()); 
    };
  }, [dispatch])

  const handleOnFinish = async (values) => {

    const payload = {
      billingAddId: investorData?.billingAddId,
      userId: user.userId,
      orgId: user.orgId,
      stateId: values.state,
      city: values.city,
      addressLine1: values.addressLine1,
      addressLine2: values.addressLine2,
      pincode: values.pincode
    }

    const res = await dispatch(updateAddressDetails(payload));

    if (res.payload.statusCode === 200) {
      dispatch(getInvestorDetailsByOrgId(user.orgId))
      setComAddEditModalOpen(false)
    }

  };

  return (
    <>
      <Title level={4}>Edit Address</Title>
      <Form
        form={form}
        layout="vertical"
        className="com-address-form"
        onFinish={handleOnFinish}
        initialValues={{
          addressLine1: investorData?.billingAddLine1 || "",
          addressLine2: investorData?.billingAddLine2 || "",
          city: investorData?.billingCityName || "",
          state: investorData?.billingStateId || "",
          pincode: investorData?.billingZipCode || "",
        }}
      >
        <CustomInput
          label="Address Line 1"
          name="addressLine1"
          type="text"
          placeholder="Enter Address Line 1"
          rules={address1Rules}
        />

        <CustomInput
          label="Address Line 2"
          name="addressLine2"
          type="text"
          placeholder="Enter Address Line 2"
          rules={address2Rules}
        />

        <CustomInput
          label="City"
          name="city"
          type="text"
          placeholder="Enter City"
          rules={cityRules}
        />

        <CustomSelect
          label="State"
          name="state"
          showSearch
          placeholder="Select State"
          className="custom-edit-dropdowns-select"
          options={statesData?.map((state) => ({
            value: state.stateId,
            label: capitalizeWords(state.stateName)
          }))
          }
          rules={[{ required: true, message: ERROR_MSGS.SEL_STATE }]}
        />

        <CustomInput
          label="Pin Code"
          name="pincode"
          type="number"
          placeholder="Enter Pincode"
          rules={pincodeRules}
        />

        {editAddError && (
          <Alert style={{ marginBottom: 20 }} message={editAddError} type="error" showIcon />
        )}

        <Form.Item>
          <CustomButton type="primary" htmlType="submit" loading={editAddLoading} block>
            {BTN_TXT.SAVE_ADD}
          </CustomButton>
        </Form.Item>
      </Form>
    </>
  );
};

export default ComAddressForm;
